import React, {useState, useEffect, useContext} from 'react'
import styled from 'styled-components';
import UserContext from '../../context/context';
import { history } from '../../_helpers';

import Modal from '../Nav/Modal'


function ComHome() {
  const [data, setData] = useState(null)
  const [state, actions] = useContext(UserContext)

  let user = JSON.parse(String(localStorage.getItem('user')))
  // console.log(user)

  let email = String(localStorage.getItem('email'))
  // console.log(email)

  useEffect(()=>{
    async function fetchData(){
      // console.log(localStorage.getItem('user'))
      // console.log(JSON.parse(String(localStorage.getItem('user'))))
      // let user = JSON.parse(String(localStorage.getItem('user')))
      // console.log(user.user.email)
      // actions.setIsShowing(true)

      // const res = await fetch(aws_link + "/user/confirm/?user=" + email, {
      //   method: 'GET',
      //   // headers: {Authorization: `JWT ${user.token}`},
      // });
      // res
      //   .json()
      //   .then(res => setData(res))
    }

    // console.log(data)

    // if (data === null){
    //   fetchData();
    // }
    // const header = {Authorization: `JWT ${user.token}`}

    if(user){
      const header = {Authorization: `JWT ${user.token}`}
      async function fetchAllData(){
        fetch(state.awslink + "/user/alldata/", {
          method: 'GET',
          headers: header,
        })
        .then(response => response.json())
        .then(json=>{
          if(localStorage.getItem('is_headhunter') === "true"){

          }
          else if(localStorage.getItem('is_recruiter') === "true"){
            if(json["company#"] === 0){
              history.push("/recruiter/signIn")
            }
          }
          else{
            history.push("/recruiter/signIn")
          }
          
        })   
      }
      fetchAllData();
    }
  })

  // function handleLoginSubmit (user.user.email) {
  //   WebSocketInstance.connect();
  // }

  return(
    <Wrapper>
      <MidWrapper>
        
        COMPANY HOME
      </MidWrapper>
    </Wrapper>   
  )
}

export default ComHome;


const Wrapper = styled.div`
  display: flex;
  
  width: 100vw;
  height: calc(100vh - 45px);

  margin-top: 45px;

  justify-content: center;
  align-items: center;

  /* border: green solid; */
  background-color: whitesmoke;
`
const MidWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 980px;
  height: 100%;
  justify-content: center;
  align-items: center;

  background-color: whitesmoke;
  /* border: red solid; */
  /* border-radius: 5px; */

  flex-direction: row;
`